import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import type { Location } from 'react-router-dom'
import {
  NavigateFunction,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { addTrackToGroups } from '@disco/state-management/actions/ExplorerActions'
import {
  createGroup,
  updateGroup,
} from '@disco/state-management/actions/GroupActions'
import { getGroup } from '@disco/state-management/selectors/groups'
import { getTrack } from '@disco/state-management/selectors/tracks'

import type { State } from 'types/redux'

import DocumentHeadTags from 'components/document-head-tags'
import AddToNewChannelModal from 'components/modals/track/add-to-new-channel'

import type { RootState } from 'store/configureStore'

interface OwnProps {
  params: {
    trackId: string
  }
  navigate: NavigateFunction
  location: Location
  searchParams: URLSearchParams
}

function mapStateToProps(state: RootState, props: OwnProps) {
  return {
    track: getTrack(state, {
      id: parseInt(props.params.trackId, 10),
    }),
    sourceGroup: getGroup(state, {
      groupId: parseInt(props.searchParams.get('source_group'), 10),
    }),
    sourcePlaylistId: props.searchParams.get('source_playlist')
      ? parseInt(props.searchParams.get('source_playlist'), 10)
      : undefined,
    user: state.user,
  }
}

const mapDispatchToProps = {
  addTrackToGroups,
  createGroup,
  updateGroup,
  sendMixpanelEvent,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type AddToNewChannelProps = PropsFromRedux & OwnProps

class AddToNewChannel extends Component<AddToNewChannelProps> {
  _onClose = () => this.props.navigate('/')

  render() {
    return (
      <div>
        <DocumentHeadTags title="Add to new channel | DISCO" />
        <AddToNewChannelModal
          createGroup={this.props.createGroup}
          updateGroup={this.props.updateGroup}
          user={this.props.user}
          track={this.props.track}
          sourceGroup={this.props.sourceGroup}
          sourcePlaylistId={this.props.sourcePlaylistId}
          onClose={this._onClose}
          addTrackToGroups={this.props.addTrackToGroups}
          sendMixpanelEvent={this.props.sendMixpanelEvent}
        />
      </div>
    )
  }
}

const ConnectedAddToNewChannel = connector(AddToNewChannel)

// Wrapper component to provide router params and navigation to the connected component
const AddToNewChannelWithRouter = (props: any) => {
  const params = useParams<{ trackId: string }>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  return (
    <ConnectedAddToNewChannel
      {...props}
      params={params}
      navigate={navigate}
      searchParams={searchParams}
    />
  )
}

export default AddToNewChannelWithRouter
